import { IconProps } from '@/types/icon';

export function IconeAjuda(props: IconProps) {
  const { size } = props;
  return (
    <svg
      aria-hidden="true"
      focusable="false"
      data-prefix="fab"
      data-icon="ajuda"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width={size}
      height={size}
      {...props}
    >
      <rect width="16" height="16" fill="currentColor" fillOpacity="0.01" />
      <path
        d="M7.33334 12H8.66668V10.6667H7.33334V12ZM8.00001 1.33337C4.32001 1.33337 1.33334 4.32004 1.33334 8.00004C1.33334 11.68 4.32001 14.6667 8.00001 14.6667C11.68 14.6667 14.6667 11.68 14.6667 8.00004C14.6667 4.32004 11.68 1.33337 8.00001 1.33337ZM8.00001 13.3334C5.06001 13.3334 2.66668 10.94 2.66668 8.00004C2.66668 5.06004 5.06001 2.66671 8.00001 2.66671C10.94 2.66671 13.3333 5.06004 13.3333 8.00004C13.3333 10.94 10.94 13.3334 8.00001 13.3334ZM8.00001 4.00004C6.52668 4.00004 5.33334 5.19337 5.33334 6.66671H6.66668C6.66668 5.93337 7.26668 5.33337 8.00001 5.33337C8.73334 5.33337 9.33334 5.93337 9.33334 6.66671C9.33334 8.00004 7.33334 7.83337 7.33334 10H8.66668C8.66668 8.50004 10.6667 8.33337 10.6667 6.66671C10.6667 5.19337 9.47334 4.00004 8.00001 4.00004Z"
        fill="currentColor"
      />
    </svg>
  );
}
